import React from 'react'

import { Link } from 'react-router-dom'

import {
  PageIntroContainer,
  LogoImage,
  ButtonContainer,
  Text,
  ButtonLogin,
} from './styles'

import logoImage from '../../../../assets/png/logo-intro.png'
import grupoIntro from '../../../../assets/svg/GrupoIntro.svg'

import { Authority } from '../../../../enums'

type Iprops = any

function PageIntro({ handleButtonClick }: Iprops) {
  return (
    <PageIntroContainer>
      <LogoImage src={logoImage} alt="Logo" />
      <LogoImage src={grupoIntro} alt="Logo" />
      <Text>
        Seja bem-vindo à maior plataforma de busca por médicos do Brasil!
      </Text>
      <ButtonContainer>
        <Link to="/intro/doctors" style={{ textDecoration: 'none' }}>
          <ButtonLogin onClick={() => handleButtonClick(Authority.DOCTOR)}>
            Sou Médico
          </ButtonLogin>
        </Link>
        <Link to="/intro/contractors" style={{ textDecoration: 'none' }}>
          <ButtonLogin onClick={() => handleButtonClick(Authority.CONTRACTOR)}>
            Sou Contratante
          </ButtonLogin>
        </Link>
      </ButtonContainer>
    </PageIntroContainer>
  )
}

export default PageIntro
